import React from 'react';

export default function MySubordinatesSummaryCards({ summary }) {
  const cards = [
    {
      label: 'Direct Subordinates',
      value: String(summary?.totalSubordinates || 0),
      subtext: 'Direct reporting team members',
      icon: 'supervisor_account',
      color: 'text-primary',
      bg: 'bg-primary/10',
    },
    {
      label: 'Active & On Duty',
      value: String(summary?.activeCount || 0),
      subtext: 'Working & logged in today',
      icon: 'check_circle',
      color: 'text-emerald-600',
      bg: 'bg-emerald-500/10',
    },
    {
      label: 'Pending Approvals',
      value: String(summary?.pendingRequestsTotal || 0),
      subtext: 'Leave / regularization requests',
      icon: 'pending_actions',
      color: 'text-amber-600',
      bg: 'bg-amber-500/10',
    },
    {
      label: 'Functional Areas',
      value: String(summary?.departmentCount || 0),
      subtext: 'Subordinate departments',
      icon: 'hub',
      color: 'text-indigo-600',
      bg: 'bg-indigo-500/10',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => (
        <div
          key={index}
          className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-5 shadow-xs transition-all hover:shadow-sm"
        >
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-slate-600 uppercase tracking-wider">
              {card.label}
            </span>
            <div className={`flex h-9 w-9 items-center justify-center rounded-xl ${card.bg} ${card.color}`}>
              <span className="material-symbols-outlined text-lg">{card.icon}</span>
            </div>
          </div>
          <div className="mt-3">
            <span className="font-sans text-2xl font-extrabold text-on-surface tabular-nums tracking-tight">
              {card.value}
            </span>
            <p className="text-[11px] font-semibold text-slate-500 mt-0.5">{card.subtext}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
